// Invoices index
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state: {
    items: [],
    count: '',
    entity: {},
    invoice: {},
  },
  actions,
  mutations,
  getters,
};
